// extracted by mini-css-extract-plugin
export var content = "_mz-1";
export var fullScreen = "_mz-0";